import { Injectable } from '@angular/core';
import { HttpService } from '../../http.service';
import {
  ConsentFormReq,
  ConsentTemplatesService,
  CreateConsentFormReq,
} from '@services';
import { ConsentFormTemplateApi, Page } from '@models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConsentTemplatesApiService
  extends HttpService<ConsentFormTemplateApi>
  implements ConsentTemplatesService
{
  protected override readonly collectionPath = '/consent-forms/templates';

  getFormTemplates(
    params: Record<string, string | number | boolean | undefined>
  ): Observable<Page<ConsentFormTemplateApi>> {
    return this.getCollectionByQuery(params);
  }

  getFormTemplate(
    id: string,
    lang: 'en' | 'es' = 'en'
  ): Observable<ConsentFormTemplateApi> {
    return this.http.get<ConsentFormTemplateApi>(`${this.apiUrl}/${id}`, {
      params: this.getHttpParameters({ lang }),
    });
  }

  getFormTemplateNameById(id: string): Observable<string> {
    return this.http.get<string>(`${this.apiUrl}/${id}/name`);
  }

  createTemplate(
    body: CreateConsentFormReq
  ): Observable<ConsentFormTemplateApi> {
    return this.http.post<ConsentFormTemplateApi>(this.apiUrl, body);
  }

  updateTemplate(
    id: string,
    body: ConsentFormReq
  ): Observable<ConsentFormTemplateApi> {
    return this.http.patch<ConsentFormTemplateApi>(
      `${this.apiUrl}/${id}`,
      body
    );
  }

  deleteTemplate(id: number | string): Observable<unknown> {
    return this.deleteItemById(id);
  }
}
